import Vue from 'vue';
import BaiduMap from 'vue-baidu-map';

Vue.use(BaiduMap, {
    ak: 'ai2bGfHNdoLXoiDK2fIAbmqvVAIzGNAa' //官方提供的ak秘钥
})
